module.exports = __webpack_public_path__ + "img/bgwelcome01.78231fd6.jpg";